// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const WalletIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Wallet/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.875 11.367v.833a.416.416 0 0 1-.408.417H16.25c-.442 0-.842-.325-.875-.759a.832.832 0 0 1 .242-.666.792.792 0 0 1 .583-.242h1.258a.418.418 0 0 1 .417.417Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.992 10.575a1.683 1.683 0 0 0-.45 1.65c.216.775.975 1.267 1.775 1.267h.725c.458 0 .833.375.833.833v.158a3.14 3.14 0 0 1-3.133 3.134H5.175a3.14 3.14 0 0 1-3.133-3.134V8.875c0-1.025.491-1.933 1.25-2.5a3.089 3.089 0 0 1 1.883-.633h9.567a3.14 3.14 0 0 1 3.133 3.133v.367a.836.836 0 0 1-.833.833h-.85a1.66 1.66 0 0 0-1.2.5ZM13.5 4.017c.225.225.033.575-.283.575l-6.4-.009c-.367 0-.559-.45-.292-.708l1.35-1.358a2.937 2.937 0 0 1 4.133 0l1.459 1.475c.008.008.025.016.033.025Z"
}));
export default WalletIcon;